module.exports = __webpack_public_path__ + "img/Frame4249.b12516b6.png";